// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FilterModal.css */

.filter-modal-container {
  display: flex;
  min-height: 400px;
}

.filter-sidebar {
  width: 200px;
  background-color: #f5f5f5;
  padding: 20px;
  border-right: 1px solid #e0e0e0;
}

.filter-category-item {
  padding: 10px 12px;
  margin-bottom: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
}

.filter-category-item:hover {
  background-color: #ffffff;
}

.filter-category-item.active {
  background-color: #ffffff;
  border-left: 3px solid #1976d2;
  font-weight: 600;
  color: #1976d2;
}

.filter-content {
  flex: 1;
  padding: 20px;
}

.date-range-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.date-range-option:hover {
  background-color: #f9f9f9;
}

.custom-date-picker {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
}
/* ═══ DARK THEME — FilterModal ═══ */
.dark .filter-modal-container {
  background: #1e293b;
  color: #e2e8f0;
}
.dark .filter-sidebar {
  background-color: #0f172a;
  border-right-color: #334155;
  color: #e2e8f0;
}
.dark .filter-category-item { color: #94a3b8; }
.dark .filter-category-item:hover { background-color: #1e293b; }
.dark .filter-category-item.active {
  background-color: #1e293b;
  border-left-color: #3b82f6;
  color: #3b82f6;
}
.dark .filter-content { background: #1e293b; color: #e2e8f0; }
.dark .date-range-option { border-bottom-color: #334155; }
.dark .date-range-option:hover { background-color: #243043; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/StockAdjustment/components/FilterModal/FilterModal.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;AAChB;AACA,8BAA8B,cAAc,EAAE;AAC9C,oCAAoC,yBAAyB,EAAE;AAC/D;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;AACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,2BAA2B,4BAA4B,EAAE;AACzD,iCAAiC,yBAAyB,EAAE","sourcesContent":["/* FilterModal.css */\n\n.filter-modal-container {\n  display: flex;\n  min-height: 400px;\n}\n\n.filter-sidebar {\n  width: 200px;\n  background-color: #f5f5f5;\n  padding: 20px;\n  border-right: 1px solid #e0e0e0;\n}\n\n.filter-category-item {\n  padding: 10px 12px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.filter-category-item:hover {\n  background-color: #ffffff;\n}\n\n.filter-category-item.active {\n  background-color: #ffffff;\n  border-left: 3px solid #1976d2;\n  font-weight: 600;\n  color: #1976d2;\n}\n\n.filter-content {\n  flex: 1;\n  padding: 20px;\n}\n\n.date-range-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.date-range-option:hover {\n  background-color: #f9f9f9;\n}\n\n.custom-date-picker {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 20px;\n}\n/* ═══ DARK THEME — FilterModal ═══ */\n.dark .filter-modal-container {\n  background: #1e293b;\n  color: #e2e8f0;\n}\n.dark .filter-sidebar {\n  background-color: #0f172a;\n  border-right-color: #334155;\n  color: #e2e8f0;\n}\n.dark .filter-category-item { color: #94a3b8; }\n.dark .filter-category-item:hover { background-color: #1e293b; }\n.dark .filter-category-item.active {\n  background-color: #1e293b;\n  border-left-color: #3b82f6;\n  color: #3b82f6;\n}\n.dark .filter-content { background: #1e293b; color: #e2e8f0; }\n.dark .date-range-option { border-bottom-color: #334155; }\n.dark .date-range-option:hover { background-color: #243043; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
